import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {CSVTooltip} from '../Snippets/Snippets'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import './Students.css';
import '../Teachers/Teachers.css';
import { apiPath, apiKey } from '../../constants';
import finalCSV from './StudentsCSV/outputCSV/finalCSV.csv'

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
}));


function Students() {

    let fileReader;
    var userdata = JSON.parse(localStorage.getItem('kokos_userdata'));
    let countries = ['India'];
    let languages = ['English'];
    const activateArray = ['-', 'Yes', 'No'];
    const [classList,setClassList] = useState(new Set(['-']));
    const [divisionList,setDivisionList] = useState(new Set(['-']));

    const [open, setOpen] = useState(false);
    const [student, setStudent] = useState([]);
    const [initialStudentData, setinitialStudentData] = useState([]);
    const [singleStudent, setSingleStudent] = useState([]);
    const [openStdDetails, setOpenStdDetails] = useState(false);
    const [loading, setLoading] = useState(true);
    const [allclasses, setallClasses] = useState([]);
    const [classname, setClassname] = useState();
    const [popuomsg, setPopupmsg] = useState(false);
    const [message, setMessage] = useState('');
    const [msgstatus, setMsgstatus] = useState();
    const [emailstatus, setEmailStatus] = useState(true);
    const [usernamestatus, setUsernameStatus] = useState(true);
    const [selectedContry, setSelectedContry] = useState('India');
    const [selectLanguage, setSelectedLanguage] = useState('English');
    const [editstdmsg, setEditstdmsg] = useState(false);
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [selectedstudentdetails, setSelectedStudentDetails] = useState([]);
    const [isActive, editIsactive] = useState(true);
    const [isFilterActive, setIsFilterActive] = useState(false);
    const [filterClass, setFilterClass] = useState('');
    const [filterDivision, setFilterDivision] = useState('');
    const [filterName, setFilterName] = useState('');
    const [filterActivate, setFilterActivate] = useState('');
    const [firstNameError, setFirstnameerror] = useState(false);
    const [lastnameError, setLastNameError] = useState(false);
    const [emailerror, setEmailError] = useState('');
    const [loadingbtn, setloadingBtn] = useState(false);
    const [loadingbtnrestart, setloadingBtnrestart] = useState(false);
    const [classCode, setClassCode] = useState('')
    const [CSVdata, setCSVData] = useState([]);
    let numberValidationStatus = true

    useEffect(() => {
        initalFetchStudentsApiCall()
    }, [])

    useEffect(() => {
        const parseCSV = async () => {
          const response = await fetch(finalCSV);
          const text = await response.text();
          const rows = text.split("\n").map((row) => row.split(","));
        //   console.log(rows)
          setCSVData(rows);
        };
        parseCSV();
      }, []);

    const findPassword = (email)=>{
        for (let i = 0; i < CSVdata.length; i++) {
            if (CSVdata[i][1] === email) {
              return(CSVdata[i][7]);
            }
          }
    }

    const initalFetchStudentsApiCall = () => {
        async function fetchStudents() {
            const response = await fetch(apiPath+'users/schools/' + userdata.school_code + '/roles/STDNT', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
            const data = await response.json();
            // console.log(data)
            setinitialStudentData(data)
            setStudent(data)
            setLoading(false)
            fetchClassData()
        }
        fetchStudents();
    }

    const updateClassData = (data) =>{
        const classNames = new Set();
        const classDivisions = new Set();

        for(var i of data){
            if (i.class_name) classNames.add(i.class_name);
            if (i.division) classDivisions.add(i.division);
        }

        setClassList(classNames);
        setDivisionList(classDivisions);
    }

    const fetchClassData = () => {
        fetch(apiPath+'schools/' + userdata.school_code + '/class/list/all', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })
            .then(response => response.json())
            .then(data => {
                // console.log('classData',data);
                sortClasses(data)
                updateClassData(data);
                // setClassdetails(data)
            })
            .catch(error => console.log(error));
    }

    const sortClasses = (classesdetails) => {
        var classArray = [];
        for (var i = 0; i < classesdetails.length; i++) {
            classArray.push(classesdetails[i].class_code)
        }
        setallClasses(classArray)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (e,reason) => {
        //checking reason to avoid closing modal close on backdropclick
        if(!(reason && reason == 'backdropClick')) setOpen(false);
    };

    // const handleStdDetailsOpen = () => {
    //     setOpenStdDetails(true);
    // }

    // const handleStdDetailsClose = () => {
    //     setOpenStdDetails(false);
    // }

    const classes = useStyles();

    const srtingEmptyCheck = (strValue) => {
        return (!strValue.trim().length) ? false : true;
    }

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const checkValidity = (FirstName, SecondName, UserName, Password, Email) => {
        return (srtingEmptyCheck(FirstName) && srtingEmptyCheck(SecondName) && srtingEmptyCheck(UserName) && srtingEmptyCheck(Password) && validateEmail(Email)) ? true : false
    }

    const nameValidation = (field_id) => {
        let name = ''
        if (field_id === 'sname_error') {
            name = document.getElementById("sname").value;
        }
        else {
            name = document.getElementById("fname").value;
        }


        if ((srtingEmptyCheck(name) === false) || (validateNameHasNumber(name) === false)) {
            document.getElementById(field_id).innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
            numberValidationStatus = false
        }
        else {
            document.getElementById(field_id).innerHTML = "<span></span>";
        }
    }

    const emailCheck = (ID) => {
        if (validateEmail(ID) === false) {
            document.getElementById("email_error").innerHTML = "<span style='color:red;'>Please enter a vaild email id</span>";
            setEmailStatus(false)
        }
        else {
            document.getElementById("email_error").innerHTML = "<span></span>";
            var url = apiPath+'users/schools/user/email/' + ID
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status === "failed") {
                        setEmailStatus(false);
                        document.getElementById("email_error").innerHTML = "<span style='color:red;'>This email id already used</span>"
                    } else {
                        setEmailStatus(true);
                        document.getElementById("email_error").innerHTML = "<span style='color:red;'></span>"
                    }
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const UsernameCheck = (username) => {
        function hasWhiteSpace(s) {
            return s.indexOf(' ') >= 0;
          }

        if (srtingEmptyCheck(username) === false) {
            document.getElementById("uname_error").innerHTML = "<span style='color:red;'>Please enter a vaild user name</span>";
            setUsernameStatus(false)
        }
        if (hasWhiteSpace(username) === true){
            document.getElementById("uname_error").innerHTML = "<span style='color:red;'>space character is not permitted in username</span>";
            setUsernameStatus(false)
        }
        else {
            document.getElementById("uname_error").innerHTML = "<span></span>";
            var url = apiPath+'users/schools/user/username/' + username
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status === "failed") {
                        setUsernameStatus(false)
                        document.getElementById("uname_error").innerHTML = "<span style='color:red;'>This username already used</span>"
                    } else {
                        setUsernameStatus(true)
                        document.getElementById("uname_error").innerHTML = "<span style='color:red;'></span>"
                    }
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const validateNameHasNumber = (name) =>{
        let hasNumber = /^[a-zA-Z\s]*$/;
        if(hasNumber.test(name)=== false){
            return false
        }
        else{
            return true
        }
    }

    const validateforms = () => {

        var FirstName = document.getElementById("fname").value;
        var SecondName = document.getElementById("sname").value;
        var Email = document.getElementById("email").value;
        var UserName = document.getElementById("uname").value;
        var Password = document.getElementById("password").value;
        

        if((srtingEmptyCheck(UserName) === false)){
            document.getElementById("uname_error").innerHTML = "<span style='color:red;'>Please enter a vaild username</span>";
        }
        // if ((srtingEmptyCheck(FirstName) === false) || (validateNameHasNumber(FirstName)===false)) {
        //     document.getElementById("fname_error").innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
        //     numberValidationStatus = false
        // }
        // else {
        //     document.getElementById("fname_error").innerHTML = "<span></span>";
        // }
        // if ((srtingEmptyCheck(SecondName) === false) || (validateNameHasNumber(SecondName)===false)) {
        //     document.getElementById("sname_error").innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
        //     numberValidationStatus = false
        // }
        // else {
        //     document.getElementById("sname_error").innerHTML = "<span></span>";
        // }
        if (srtingEmptyCheck(Password) === false) {
            document.getElementById("pass_error").innerHTML = "<span style='color:red;'>Please enter a vaild password</span>";
        }
        else {
            document.getElementById("pass_error").innerHTML = "<span></span>";
        }


        if (numberValidationStatus && emailstatus && usernamestatus && checkValidity(FirstName, SecondName, UserName, Password, Email)) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-key': apiKey },
                body: JSON.stringify({
                    "class_code": classname,
                    "email": Email,
                    "first_name": FirstName,
                    "is_active": 1,
                    "last_name": SecondName,
                    "role_code": 'STDNT',
                    "username": UserName,
                    "password": Password,
                    "country_code": selectedContry,
                    "language": selectLanguage
                })
            };
            fetch(apiPath+'users/schools/' + userdata.school_code + '/user', requestOptions)
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message)
                    } else {
                        togglePopUpOpen(2, data.message)
                    }
                    initalFetchStudentsApiCall();
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
        }
    }

    const togglePopUpOpen = (status, data) => {
        handleClose()
        setMsgstatus(status);
        setMessage(data);
        setPopupmsg(true);
    }

    const togglePopUpClose = () => {
        setPopupmsg(false);
    }

    // const viewSingleStudent = (username) => {
    //     setLoading(true)
    //     var url = apiPath+'users/schools/' + userdata.school_code + '/user/' + username
    //     fetch(url, {
    //         method: 'GET',
    //         headers: new Headers({
    //             'Content-Type': 'application/json',
    //             'x-api-key': apiKey
    //         }),
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             setLoading(false)
    //             setSingleStudent(data)
    //             handleStdDetailsOpen()
    //         })
    //         .catch(error => {
    //             console.log('There was an error!', error);
    //         });
    // }

    const changeHandler = (event) => {
        fileReader = new FileReader();
        fileReader.onloadend = handleFileRead;
        fileReader.readAsText(event.target.files[0])
    }

    const handleFileRead = (e) => {
        const content = fileReader.result;
        csvJSON(content)
    }

    const csvJSON = (csv) => {
        console.log(csv)
        const lines = csv.split('\n')
        const result = []
        const headers = lines[0].split(',')

        for (let i = 1; i < lines.length; i++) {
            if (!lines[i])
                continue
            const obj = {}

            const currentline = lines[i].split(',')
            for (let j = 0; j < headers.length; j++) {

                if (headers[j] == "is_active") {
                    obj[headers[j].trim()] = Number(currentline[j])
                } else {
                    obj[headers[j].trim()] = currentline[j]
                }
            }
            result.push(obj)
        }
        console.log(result)
        uploadCsvFunction(result)
    }

    const uploadCsvFunction = (datacsv) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'x-api-key': apiKey },
            body: JSON.stringify(datacsv)
        };
        fetch(apiPath+'users/schools/' + userdata.school_code + '/csv', requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.success !== 0) {
                    togglePopUpOpen(1, data.message)
                } else {
                    togglePopUpOpen(2, data.message)
                }
                initalFetchStudentsApiCall();
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    const editstudentDetails = (stuData) => {
        setEditstdmsg(true);
        setSelectedStudentDetails(stuData)
        setFirstname(stuData.first_name)
        setLastname(stuData.last_name)
        setEmail(stuData.email)
        setClassCode(stuData.class.class_code)
        if (stuData.is_active === 1) {
            editIsactive(true)
        }
        else {
            editIsactive(false)
        }
    }

    const toggleisActiveSwitch = () => {
        editIsactive(!isActive)
    }

    const closeEditModal = () => {
        setEditstdmsg(false);
        setFirstnameerror(false);
        setLastNameError(false)
        
    }

    const setSelectedStudentValues = (event, type) => {
        if (type == 1) {
            setFirstname(event)
        }
        if (type == 2) {
            setLastname(event)
        }
        if (type == 3) {
            setEmail(event)
        }
    }

    const editstudentDetailsApiCall = () => {
        if (emailerror.length === 0 && !firstNameError && !lastnameError) {
            setloadingBtn(true)
            var active
            if (isActive === true) {
                active = '1'
            } else {
                active = '0'
            }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                },
                body: JSON.stringify({
                    "user_code": selectedstudentdetails.user_id,
                    "first_name": firstname,
                    "last_name": lastname,
                    "email": email,
                    "is_active": active,
                    "role_code": "STDNT"
                })
            };
            fetch(apiPath+'users/schools/' + userdata.school_code + '/user/' + selectedstudentdetails.username + '/user/update', requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message)
                    } else {
                        togglePopUpOpen(2, data.message)
                    }
                    setloadingBtn(false)
                    initalFetchStudentsApiCall();
                    setEditstdmsg(false)
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const resetPassword = () => {
        setloadingBtnrestart(true)
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify({
            })
        };
        fetch(apiPath+'users/schools/' + userdata.school_code + '/user/' + selectedstudentdetails.username + '/resetpassword', requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    togglePopUpOpen(1, data.message + '\n The new password is: ' + data.new_password)
                } else {
                    togglePopUpOpen(2, data.message)
                }
                setloadingBtnrestart(false)
                setEditstdmsg(false)
                initalFetchStudentsApiCall();
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    const filterToggle = () => {
        if(isFilterActive) resetFilter();
        setIsFilterActive(!isFilterActive)
    }

    const resetFilter = () =>{
        setFilterClass('');
        setFilterDivision('');
        setFilterName('');
        setFilterActivate('');
        setStudent(initialStudentData);
    }

    const applyFilter = () => {
        let studentsArray = initialStudentData;
        var temp = []
        if (filterClass.length !== 0) {
            var tempone = studentsArray.filter(o => o.class.class_name === filterClass)
            if (tempone !== undefined) {
                studentsArray = tempone
            }
        if((filterClass == '' || filterClass == '-')){
            studentsArray = initialStudentData;
        }
        }

        if (filterDivision.length !== 0 && filterDivision !=='-') {
            var tempone = studentsArray.filter(o => o.class.division === filterDivision.toUpperCase())
            if (tempone !== undefined) {
                studentsArray = tempone
            }
        }

        if (filterName.length !== 0) {
            var tempone = studentsArray.filter(o => o.username.includes(filterName.trim()))
            console.log(tempone);
            if (tempone !== undefined) {
                studentsArray = tempone
            }
        }

        if (filterActivate == 'Yes') {
            var tempone = studentsArray.filter(o => o.is_active === 1)
            studentsArray = tempone
        }
        if (filterActivate == 'No') {
            var tempone = studentsArray.filter(o => o.is_active === 0)
            // console.log(tempone)
            studentsArray = tempone
        }

        setStudent(studentsArray)
    }

    const firstNameCheck = () => {
        var hasNumber = /^[a-zA-Z\s]*$/;
        if (firstname.length !== 0 && hasNumber.test(firstname) === true) {
            if (!firstname.replace(/\s/g, '').length) {
                setFirstnameerror(true)
              }
            else{setFirstnameerror(false)}
            
        } else {
            setFirstnameerror(true)
        }
    }

    const LastNameCheck = () => {
        var hasNumber = /^[a-zA-Z\s]*$/;
        if (lastname.length !== 0 && hasNumber.test(lastname) === true) {
            if (!lastname.replace(/\s/g, '').length) {
                setLastNameError(true)
              }
            else{setLastNameError(false)}
            
        } else {
            setLastNameError(true)
        }
    }

    const checkEmailValidity = () => {
        if (email.length === 0) {
            setEmailError('*Please enter a valid email Id')
        }
        if (validateEmail(email) === false) {
            setEmailError('*Please enter a vaild email Id')
        } else {
            setEmailError('')
        }
        if (email.length !== 0 && selectedstudentdetails.email !== email && validateEmail(email) === true) {
            var url = apiPath+'users/schools/user/email/' + email
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status == 'failed') {
                        setEmailError(data.message)
                    } else {
                        setEmailError('')
                    }

                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const updateFilterClass = (value)=>{
        if(value == '' || value == '-') setFilterDivision('')
        setFilterClass(value)
    }

    return (
        <div className="Studentsmain">
            <div className="Students_Button_Main">
                {userdata?.role_code!=='STDADMN'?<div className="fileUpload Students_button_new" >
                    <span>Load From csv</span>
                    <input id="fileupload" type="file" className="upload" accept='.csv' onChange={changeHandler} />
                </div>:<div></div>}
                {userdata?.role_code!=='STDADMN'?<CSVTooltip filetype={'students'}/>:<div></div>}
                {userdata?.role_code!=='STDADMN'?<div className="Students_button_new" onClick={handleClickOpen}>
                    Add Student
                </div>:<div></div>}
                <div className="Students_button_new" onClick={() => filterToggle()}>Filter</div>
            </div>
            {
                isFilterActive &&
                <div className="studentpageFilterOutter">
                    <div className="studentpageFilter">
                        <div className="studentpageFilterDetails">
                            <div className="filterclassName">Class</div>
                            <select className="filterClassDropdown"
                                onChange={e => updateFilterClass(e.target.value)}
                                value={filterClass}>
                                {
                                    ['-',...classList].sort(function(a, b){return a-b}).map((allclass, index) => {
                                        return (
                                            <option key={index} value={allclass}>
                                                {allclass}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        <div className="studentpageFilterDetails">
                            <div className="filterclassName">Div</div>
                            <select disabled={(filterClass == '' || filterClass == '-')? true : false} className="filterClassDropdown"
                                onChange={e => {setFilterDivision(e.target.value)}}
                                value={filterDivision}>
                                {
                                    ['-',...divisionList].sort().map((allDivision, index) => {
                                        return (
                                            <option key={index} value={allDivision}>
                                                {allDivision}
                                            </option>
                                        )
                                    })
                                }

                            </select>
                        </div>
                        <div className="studentpageFilterDetails">
                            <div>Username</div>
                            <input className="filterTextInput" type="text" value={filterName}
                                onChange={e => setFilterName(e.target.value)}
                            />
                        </div>
                        <div className="studentpageFilterDetails">
                            <div>Active:</div>
                            <select className="filter_dropdown"
                                onChange={e => setFilterActivate(e.target.value)}
                                value={filterActivate}>
                                {
                                    activateArray.map((activate, index) => {
                                        return (
                                            <option key={index} value={activate}>
                                                {activate}
                                            </option>
                                        );
                                    })}
                            </select>
                        </div>
                        <div className="filterApplyBtn" onClick={() => applyFilter()}>Search</div>
                        <div className="filterApplyBtn" onClick={() => resetFilter()}>Reset</div>
                    </div>
                    <img className="studentpageFilterclose" onClick={() => filterToggle()} src={require('../../images/close.png')} />
                </div>
            }
            {
                loading ?
                    <img className="loadingSymbol" src={require('../../images/loading2.gif')} alt="loading" />
                    :
                    <div className={`fixTableHead-${isFilterActive}`}>
                        <table>
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>Full Name</th>
                                    <th>Class</th>
                                    <th>User Name</th>
                                    <th>Email</th>
                                    <th>Active</th>
                                    <th>Login</th>
                                    {userdata?.role_code!=='STDADMN'?<th>Update Student</th>:null}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    student && student.map((student_details, index) => {   
                                        const password = findPassword(student_details.email)
                                        student_details={...student_details,password:password}
                                        return (
                                            <tr key={student_details.user_id}>
                                                <td>{index + 1}</td>
                                                <td>{student_details.first_name}&nbsp;{student_details.last_name}</td>
                                                <td>{student_details.class.class_code}</td>
                                                <td>{student_details.username}</td>
                                                <td>{student_details.email}</td>
                                                {
                                                    student_details.is_active === 1 ?
                                                        <td>Yes</td> : <td>No</td>
                                                }
                                                <td ><div className="student_editButton_outter">{student_details.password?<div className="student_editButton"><a style={{color:'#27c3d6',textDecoration:'none'}} target='_blank' href={`https://${userdata.school_code}.kokos.ai/login?email=${student_details.email}&password=${student_details.password}`}>Login</a></div>:<div>unavailable</div>}</div></td>
                                                {userdata?.role_code!=='STDADMN'?<td className="student_editButton_outter">
                                                    <div className="student_editButton" onClick={() => editstudentDetails(student_details)}>Edit</div>
                                                </td>:null}
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
            }
            <div>
                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Student Details
                    </DialogTitle>
                    <DialogContent dividers>
                        <form autoComplete="off" style={{ padding: '0vw 4vw' }}>
                            <input id="fname" className="input_teachers" type="text" placeholder="First Name" 
                            onBlur={e => nameValidation('fname_error')}/>
                            <div className="fname_name" id='fname_error'></div>
                            <input id="sname" className="input_teachers" type="text" placeholder="Last Name" 
                            onBlur={e => nameValidation('sname_error')}/>
                            <div className="sname_name" id='sname_error'></div>
                            <input id="email" className="input_teachers" type="text" placeholder="Email"
                                 onBlur={e => emailCheck(e.target.value)} />
                            <div className="sname_name" id='email_error'></div>
                            <div className="class_techer_select">
                                <div className="class_techer_select_heading">Select class Id</div>
                                <select className="class_techer_dropdown"
                                    onChange={e => setClassname(e.target.value)}
                                    onBlur={e => setClassname(e.target.value)}
                                    value={classname}>
                                    {
                                        allclasses && allclasses.map((class_name, index) => {
                                            return (
                                                <option key={index} value={class_name}>
                                                    {class_name}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                            <div className="class_techer_select">
                                <div className="class_techer_select_heading">Select country</div>
                                <select className="class_techer_dropdown"
                                    onChange={e => setSelectedContry(e.target.value)}
                                    onBlur={e => setSelectedContry(e.target.value)}
                                    value={selectedContry}>
                                    {
                                        countries.map((country_name, index) => {
                                            return (
                                                <option key={index} value={country_name}>
                                                    {country_name}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                            <div className="class_techer_select">
                                <div className="class_techer_select_heading">Select language</div>
                                <select className="class_techer_dropdown"
                                    onChange={e => setSelectedLanguage(e.target.value)}
                                    onBlur={e => setSelectedLanguage(e.target.value)}
                                    value={selectLanguage}>
                                    {
                                        languages.map((language, index) => {
                                            return (
                                                <option key={index} value={language}>
                                                    {language}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                            <input id="uname" className="input_teachers" type="text"
                                onBlur={e => UsernameCheck(e.target.value)} placeholder="User Name" />
                            <div className="sname_name" id='uname_error'></div>
                            <input id="password" className="input_teachers" type="password" placeholder="Password" autoComplete="new-password" />
                            <div className="sname_name" id='pass_error'></div>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={validateforms} color="primary">
                            Create
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div className={`popUpModalBackground popUpmodalShowing-${popuomsg}`}>
                {
                    (msgstatus && msgstatus === 1) ?
                        <div>
                            <div className="popUpModal-success">
                                <img className="popUpModal-successimg" src={require('../../images/success.png')} />
                            </div>
                            <div className="popUpModal-Content">
                                {message}
                                <div className="popUpModal-submitOutter">
                                    <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="popUpModal-success">
                                <img className="popUpModal-successimg" src={require('../../images/warning.png')} />
                            </div>
                            <div className="popUpModal-Content">
                                {message}
                                <div className="popUpModal-submitOutter">
                                    <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
                                </div>
                            </div>
                        </div>
                }
            </div>
            <div className={`studentspageEditstudent editmodalShowing-${editstdmsg}`}>
                <div className="editmodal_close_img_div">
                    <img onClick={closeEditModal} className="editmodal_close" src={require('../../images/close.png')} />
                </div>
                <div className="editTeacherHeading">Edit Student Details</div>
                <div className="std-edit_resetpassword_outter">
                    {
                        isActive && isActive === true ?
                            <img className="std-edittogglebutton" onClick={() => toggleisActiveSwitch()}
                                src={require('../../images/switch.png')} />
                            :
                            <img className="std-edittogglebutton" onClick={() => toggleisActiveSwitch()}
                                src={require('../../images/switchoff.png')} />
                    }
                    <div className="std-editactive">
                        Active :
                    </div>
                </div>
                <div className="std-editModalClassDetails">Class : {classCode}</div>
                <div className="std-editModalBackground_outter">
                    <form autoComplete="off" className="std-edit_input_outter">
                        <div>
                            <div className="std_firstname_style">First Name :</div>
                            <input id="editfname" className="std-edit_input_teachers" type="text"
                                value={firstname} onChange={e => setFirstname(e.target.value)}
                                onBlur={e => firstNameCheck(e.target.value)}
                            />
                        </div>
                        {firstNameError && <div className="emailwarningmessage">*Please enter valid first name</div>}
                        <div>
                            <div className="std_firstname_style">Last Name :</div>
                            <input id="editlname" className="std-edit_input_teachers" type="text"
                                value={lastname} onChange={e => setLastname(e.target.value)}
                                onBlur={e => LastNameCheck(e.target.value)}
                            />
                        </div>
                        {lastnameError && <div className="emailwarningmessage">*Please enter vaild last name</div>}
                        <div>
                            <div className="std_firstname_style">Email ID :</div>
                            <input id="editemail" className="std-edit_input_teachers" type="email"
                                value={email} onBlur={e => emailCheck(e.target.value)} onChange={e => setEmail(e.target.value)}
                                 />
                            <div className="emailwarningmessage">{emailerror}</div>
                        </div>
                        {
                            // <div className="emailwarningmessage">* invaild email id</div>
                        }
                    </form>
                </div>
                <div className="std-edit_resetpassword_outter">
                    {loadingbtnrestart ? <div className="edit_resetpassword_btn_restart"><div class="loader"></div></div> :
                        <div className="edit_resetpassword_btn" onClick={() => resetPassword()}>Reset Password</div>}
                    {loadingbtn ? <div className="edit_resetpassword_btn_loading"><div class="loader"></div></div> :
                        <div className="edit_resetpassword_btn" onClick={() => editstudentDetailsApiCall()}>Update</div>}

                </div>
            </div>
        </div>
    );
}

export default Students;